import { call, put, takeLatest } from 'redux-saga/effects';
import {
  CASE_FETCH_CASE_ARTEFACTS_BEGIN,
  CASE_FETCH_CASE_ARTEFACTS_SUCCESS,
  CASE_FETCH_CASE_ARTEFACTS_FAILURE,
  CASE_FETCH_CASE_ARTEFACTS_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';

export const fetchCaseArtefacts = createPromiseAction(CASE_FETCH_CASE_ARTEFACTS_BEGIN);

export function dismissFetchCaseArtefactsFeedback() {
  return {
    type: CASE_FETCH_CASE_ARTEFACTS_DISMISS_FEEDBACK,
  };
}

export function* doFetchCaseArtefacts(action) {
  const {
    payload: { caseId },
  } = action;
  const res = yield call(api.get, `/cases/${caseId}/artefacts`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_CASE_ARTEFACTS_FAILURE,
      feedback: {
        message: 'feedback.fetchCaseArtefactsFailure',
        error: res.error,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_CASE_ARTEFACTS_SUCCESS,
    data: res,
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchFetchCaseArtefacts() {
  yield takeLatest(fetchCaseArtefacts, withCurrentCaseId(doFetchCaseArtefacts));
}

export function useFetchCaseArtefacts() {
  const dispatch = useDispatch();

  const { caseArtefacts, caseArtefactsPending, caseArtefactsFeedback } = useSelector(
    (state) => ({
      caseArtefacts: state.case.caseArtefacts,
      caseArtefactsPending: state.case.caseArtefactsPending,
      caseArtefactsFeedback: state.case.caseArtefactsFeedback,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(fetchCaseArtefacts(...args));
    },
    [dispatch],
  );

  const boundDismissFeedback = useCallback(() => {
    return dispatch(dismissFetchCaseArtefactsFeedback());
  }, [dispatch]);

  return {
    caseArtefacts,
    fetchCaseArtefacts: boundAction,
    caseArtefactsPending,
    caseArtefactsFeedback,
    dismissFetchCaseArtefactsFeedback: boundDismissFeedback,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_CASE_ARTEFACTS_BEGIN + '.TRIGGER':
      return {
        ...state,
        caseArtefactsPending: true,
        caseArtefactsFeedback: null,
      };

    case CASE_FETCH_CASE_ARTEFACTS_SUCCESS:
      return {
        ...state,
        caseArtefactsPending: false,
        caseArtefactsFeedback: action.feedback,
        caseArtefacts: action.data,
      };

    case CASE_FETCH_CASE_ARTEFACTS_FAILURE:
      return {
        ...state,
        caseArtefactsPending: false,
        caseArtefactsFeedback: action.feedback,
      };

    case CASE_FETCH_CASE_ARTEFACTS_DISMISS_FEEDBACK:
      return {
        ...state,
        caseArtefactsFeedback: null,
      };

    default:
      return state;
  }
}
